import { render, staticRenderFns } from "./NotificationPage.vue?vue&type=template&id=21e57df2&scoped=true"
import script from "./NotificationPage.vue?vue&type=script&lang=ts"
export * from "./NotificationPage.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPage.vue?vue&type=style&index=0&id=21e57df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e57df2",
  null
  
)

export default component.exports